import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorOtcPremiumPricing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M14.997 9.05a.75.75 0 0 1 .746.85.749.749 0 0 1-.213.63l-4 4a.75.75 0 0 1-.808.166L8.68 13.88l-3.65 3.65a.75.75 0 1 1-1.061-1.06l4-4a.75.75 0 0 1 .809-.166l2.04.816 2.564-2.564-2.38.01a.75.75 0 1 1-.006-1.5l4-.016Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M12 3.75a8.25 8.25 0 0 0-6.861 12.833.75.75 0 0 1-1.247.834A9.708 9.708 0 0 1 2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75a9.708 9.708 0 0 1-5.417-1.642.75.75 0 1 1 .834-1.247A8.25 8.25 0 1 0 12 3.75Z"
    />
  </svg>
);
export default SvgTwoColorOtcPremiumPricing;
